export default __webpack_public_path__ + "static/media/23-1.003119ba.mp3";